import React, { useState } from 'react';
import { useEffect } from 'react';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';

const MenuCustom = ({ Child, options, optionsSelected }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClose = (id) => {
    if (optionsSelected) optionsSelected(id)
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <Box display='flex' flexDirection='row' alignSelf='flex-start'>
      <IconButton
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <Child />
      </IconButton>
      {options && options.length > 0 &&
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {options.map(option => (
          <MenuItem key={option.id} onClick={() => handleClose(option)}>
            {option && option.Icon && <option.Icon />}
            {option.name}
          </MenuItem>
        ))}
      </Menu>}
    </Box>
  )
}

export default MenuCustom;